import React from 'react';
import { Container, Stack, Heading } from '@hover/blueprint';
import Basics from './basics';
import Premium from './premium';

const PlansAndPricing: React.FC = () => (
  <Container maxW="8xl" centerContent px={500} mb="80px">
    <Heading
      size={{ base: 600, tablet: 700, desktop: 800 }}
      mt={{ base: 700, tablet: '80px', desktop: '88px' }}
      marginBottom={{ base: 600, desktop: '56px' }}
    >
      Plans and Pricing
    </Heading>
    <Stack
      spacing={{ base: 500, tablet: 400, desktop: 600 }}
      direction={{ base: 'column', tablet: 'row' }}
      alignItems="flex-end"
    >
      <Basics mb={{ base: 0, tablet: 400 }} />
      <Premium />
    </Stack>
  </Container>
);

export default PlansAndPricing;
